"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const common_1 = require("@components/common");
const typography_1 = require("@components/typography");
const play_svg_1 = __importDefault(require("@components/icons/play.svg"));
const Flex_1 = __importDefault(require("@components/common/Flex"));
const _params_1 = require("@params");
const js_cookie_1 = __importDefault(require("js-cookie"));
const dateUtils_1 = require("@app/utils/dateUtils");
const locale_1 = __importDefault(require("../locale"));
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const TableRow = ({ name, date, target, cat_result, keys_errors, slug }) => (react_1.default.createElement("tr", null,
    react_1.default.createElement("td", null,
        react_1.default.createElement(Flex_1.default, { align: "center", onClick: () => { window.location.href = `/exercises/performing_exercise/${slug}`; }, style: { cursor: 'pointer' }, wrap: "nowrap" },
            react_1.default.createElement(play_svg_1.default, null),
            " \u00A0 ",
            name)),
    react_1.default.createElement("td", null, (0, dateUtils_1.formatDate)(new Date(date))),
    react_1.default.createElement("td", null,
        target,
        "%"),
    react_1.default.createElement("td", null,
        cat_result,
        "%"),
    react_1.default.createElement("td", null, keys_errors === null || keys_errors === void 0 ? void 0 : keys_errors.map(e => react_1.default.createElement("p", null, e === null || e === void 0 ? void 0 : e.feedback)))));
const ErrorsTable = () => {
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { filterState } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    const rowsRef = (0, react_1.useRef)();
    const headRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        // @ts-ignore
        rowsRef.current.addEventListener("scroll", (event) => {
            // @ts-ignore
            headRef.current.scroll({ left: event.currentTarget.scrollLeft });
        });
    }, []);
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        // @ts-ignore
        fetch(_params_1.apiHost + `/charts/mistake_table?date_start=${filterState.fromDate}&date_end=${filterState.toDate}&user=${userId}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken")
            }
        }).then(response => response.json())
            .then(response => {
            setErrors(response);
            setIsLoading(false);
        });
    }, [filterState.fromDate, filterState.toDate]);
    return (react_1.default.createElement(common_1.Plate, { padding: "10px", style: { position: 'relative' } },
        isLoading && react_1.default.createElement(CircularProgress_1.default, { className: "chart-select", size: 20, style: {
                right: '20px',
                top: '-10px'
            } }),
        react_1.default.createElement(common_1.Box, { mb: "20px" },
            react_1.default.createElement(typography_1.Paragraph, { weight: "500", size: "19px" }, locale_1.default.errorListTitle)),
        react_1.default.createElement("div", { style: { overflow: 'auto', width: '100%' }, ref: headRef },
            react_1.default.createElement("table", { className: "earning-table" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, locale_1.default.exerciseTitle),
                        react_1.default.createElement("th", null, locale_1.default.dateTitle),
                        react_1.default.createElement("th", null, locale_1.default.targetLabel),
                        react_1.default.createElement("th", null, locale_1.default.estimateLabel),
                        react_1.default.createElement("th", null, locale_1.default.commonErrorsHead))))),
        react_1.default.createElement("div", { style: { maxHeight: '400px', overflow: 'auto', width: '100%' }, ref: rowsRef },
            react_1.default.createElement("table", { className: "earning-table" },
                react_1.default.createElement("tbody", null, 
                // @ts-ignore
                errors === null || errors === void 0 ? void 0 : errors.map(e => react_1.default.createElement(TableRow, Object.assign({}, e))))))));
};
exports.default = ErrorsTable;
